import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService  } from '../core/cache.service';
import { ApiService  } from '../core/api.service';
import { Mappings} from '../../shared/mapping';
import { LocalStorageService } from "./../core/local-storage";

//Model
import { UserLogin } from "./../../models/cms/user-login";
import { CookieService } from "./cookie/cookie.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CryptoService } from "./crypto.service";

@Injectable()
export class AuthService 
{
    private loggedInUser: UserLogin = null;

    constructor
    (
        public _api: ApiService, public _cache: CacheService,
              @Inject('CookieService') private cookie: CookieService,
              private router: Router,
              private cryptoService: CryptoService    
        ) {}

    GetData() 
    {
        let user: UserLogin = new UserLogin()

        if (this.cookie.getObject("user") === undefined) 
        {
            this.loggedInUser = null;
        }

        else if (this.cookie.getObject("user") != undefined) 
        {
            let regUser = this.cookie.getObject("user");
            user.username = regUser["username"];

            user.isAuthenticated = Boolean(regUser["isAuthenticated"]);
            let registeredUser = { "isAuthenticated": user.isAuthenticated, "username": user.username }
            this.loggedInUser = registeredUser;
            user = this.loggedInUser;
        }
        
        return user;
    }

    GetUserId()
    {
        let decryptedUserId = "0";
        let encryptedUserId = this.cookie.get("qazwsxedc");
        if (encryptedUserId != null || encryptedUserId != undefined)
        {
            decryptedUserId = encryptedUserId;                        
        }
        else 
        {
            decryptedUserId = this.cryptoService.encryptNumber(Number(decryptedUserId)); 
        }
        
        return decryptedUserId;
    }

    GetDecryptedUserId()
    {
        let decryptedUserId = 0;
        let encryptedUserId = this.cookie.get("qazwsxedc");

        if (encryptedUserId != null || encryptedUserId != undefined)
        {
            decryptedUserId = this.cryptoService.decryptNumber(encryptedUserId);            
        }
        else 
        {
            decryptedUserId = Number(this.cryptoService.encryptNumber(decryptedUserId));                        
        }
        
        return decryptedUserId;
    }


    Login(id: string, username: string) 
    {
        let user: UserLogin = new UserLogin();
        
        // user.id = Number(id);
        user.isAuthenticated = true;
        user.username = username;
        
        let cryptedUserId = this.cryptoService.encryptNumber(Number(id));

        this.cookie.putObject("user", {"isAuthenticated":"true", "username":username})

        this.cookie.put("qazwsxedc", cryptedUserId);
    }

    Logout() 
    {
        this.loggedInUser = null;
        this.cookie.remove("user");
        this.cookie.remove("qazwsxedc");
        
        var currentRoute = this.router.url;

        if (currentRoute == "/it/home" || "/en/home")
        {
            window.location.reload();
        }

        this.router.navigateByUrl("");
    }

    getCurrentUserId(): string
    {        
        let userId = this.GetUserId();

        return userId;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/auth.service.ts